import BaseViewModel from './BaseViewModel';

class PageViewModel extends BaseViewModel {
	// FormElements: Array<BaseViewModel> = [];.
	PageElements: Array<BaseViewModel> = [];
	PageIndex?: number;

	Validate = () => {
		let valid = true;
		for (let i = 0; i < this.PageElements.length; i++) {
			valid = this.PageElements[i].Validate() && valid;
		}
		return valid;
	};

	//SimpleFormat
	override getSimpleFormatXmlTagName = () => {
		return 'Form';
	};

	override getSimpleFormatXmlOpen = (pageId?: string) => {
		const xml =
			'<' +
			this.getSimpleFormatXmlTagName() +
			' idRef="page_' +
			pageId +
			'" title=""';
		return xml + '>';
	};
}

export default PageViewModel;
